/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=a452dcba"
import script from "./ScrollUpButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollUpButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=a452dcba&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports